export const goToCreateCompanyForms = (company, history, user) => {
  history.push(`/${user.account_type}/companies/new/${company.id_in_provider_system}--${company.number}`);
};